/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  AddScopeOfWorkLineItemsRequest,
  AddScopeOfWorkLineItemsResponse,
  BulkUpdateScopeOfWorkFormatItemsRequest,
  ChangeOrderLineItemsOrderUpdateRequest,
  DeleteScopeOfWorkLineItemsRequest,
  LineItemsUpdateChangeOrderLineItemOrdersPutV2Params,
  LineItemsUpdateChangeOrderLineItemProfitPutV2Params,
  LineItemUpdateRequest,
  LineItemUpdateResponse,
  UpdateScopeOfWorkLineItemProfitRequest,
  UpdateScopeOfWorkLineItemProfitResponse,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const lineItemsAddChangeOrderLineItemsPostV2 = (
  addScopeOfWorkLineItemsRequest: BodyType<AddScopeOfWorkLineItemsRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AddScopeOfWorkLineItemsResponse>(
    {
      url: `/apix/v2/LineItems/add-change-order-line-items`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: addScopeOfWorkLineItemsRequest,
      signal,
    },
    options,
  );
};

export const getLineItemsAddChangeOrderLineItemsPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsAddChangeOrderLineItemsPostV2>>,
    TError,
    { data: BodyType<AddScopeOfWorkLineItemsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lineItemsAddChangeOrderLineItemsPostV2>>,
  TError,
  { data: BodyType<AddScopeOfWorkLineItemsRequest> },
  TContext
> => {
  const mutationKey = ["lineItemsAddChangeOrderLineItemsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lineItemsAddChangeOrderLineItemsPostV2>>,
    { data: BodyType<AddScopeOfWorkLineItemsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return lineItemsAddChangeOrderLineItemsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LineItemsAddChangeOrderLineItemsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof lineItemsAddChangeOrderLineItemsPostV2>>
>;
export type LineItemsAddChangeOrderLineItemsPostV2MutationBody =
  BodyType<AddScopeOfWorkLineItemsRequest>;
export type LineItemsAddChangeOrderLineItemsPostV2MutationError =
  ErrorType<unknown>;

export const useLineItemsAddChangeOrderLineItemsPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsAddChangeOrderLineItemsPostV2>>,
    TError,
    { data: BodyType<AddScopeOfWorkLineItemsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lineItemsAddChangeOrderLineItemsPostV2>>,
  TError,
  { data: BodyType<AddScopeOfWorkLineItemsRequest> },
  TContext
> => {
  const mutationOptions =
    getLineItemsAddChangeOrderLineItemsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const lineItemsAddEstimateLineItemsPostV2 = (
  addScopeOfWorkLineItemsRequest: BodyType<AddScopeOfWorkLineItemsRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AddScopeOfWorkLineItemsResponse>(
    {
      url: `/apix/v2/LineItems/add-estimate-line-items`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: addScopeOfWorkLineItemsRequest,
      signal,
    },
    options,
  );
};

export const getLineItemsAddEstimateLineItemsPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsAddEstimateLineItemsPostV2>>,
    TError,
    { data: BodyType<AddScopeOfWorkLineItemsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lineItemsAddEstimateLineItemsPostV2>>,
  TError,
  { data: BodyType<AddScopeOfWorkLineItemsRequest> },
  TContext
> => {
  const mutationKey = ["lineItemsAddEstimateLineItemsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lineItemsAddEstimateLineItemsPostV2>>,
    { data: BodyType<AddScopeOfWorkLineItemsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return lineItemsAddEstimateLineItemsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LineItemsAddEstimateLineItemsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof lineItemsAddEstimateLineItemsPostV2>>
>;
export type LineItemsAddEstimateLineItemsPostV2MutationBody =
  BodyType<AddScopeOfWorkLineItemsRequest>;
export type LineItemsAddEstimateLineItemsPostV2MutationError =
  ErrorType<unknown>;

export const useLineItemsAddEstimateLineItemsPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsAddEstimateLineItemsPostV2>>,
    TError,
    { data: BodyType<AddScopeOfWorkLineItemsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lineItemsAddEstimateLineItemsPostV2>>,
  TError,
  { data: BodyType<AddScopeOfWorkLineItemsRequest> },
  TContext
> => {
  const mutationOptions =
    getLineItemsAddEstimateLineItemsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const lineItemsUpdateEstimateLineItemPutV2 = (
  lineItemUpdateRequest: BodyType<LineItemUpdateRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<LineItemUpdateResponse>(
    {
      url: `/apix/v2/LineItems/update-estimate-line-item`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: lineItemUpdateRequest,
    },
    options,
  );
};

export const getLineItemsUpdateEstimateLineItemPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsUpdateEstimateLineItemPutV2>>,
    TError,
    { data: BodyType<LineItemUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lineItemsUpdateEstimateLineItemPutV2>>,
  TError,
  { data: BodyType<LineItemUpdateRequest> },
  TContext
> => {
  const mutationKey = ["lineItemsUpdateEstimateLineItemPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lineItemsUpdateEstimateLineItemPutV2>>,
    { data: BodyType<LineItemUpdateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return lineItemsUpdateEstimateLineItemPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LineItemsUpdateEstimateLineItemPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof lineItemsUpdateEstimateLineItemPutV2>>
>;
export type LineItemsUpdateEstimateLineItemPutV2MutationBody =
  BodyType<LineItemUpdateRequest>;
export type LineItemsUpdateEstimateLineItemPutV2MutationError =
  ErrorType<unknown>;

export const useLineItemsUpdateEstimateLineItemPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsUpdateEstimateLineItemPutV2>>,
    TError,
    { data: BodyType<LineItemUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lineItemsUpdateEstimateLineItemPutV2>>,
  TError,
  { data: BodyType<LineItemUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getLineItemsUpdateEstimateLineItemPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const lineItemsUpdateChangeOrderLineItemPutV2 = (
  lineItemUpdateRequest: BodyType<LineItemUpdateRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<LineItemUpdateResponse>(
    {
      url: `/apix/v2/LineItems/update-change-order-line-item`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: lineItemUpdateRequest,
    },
    options,
  );
};

export const getLineItemsUpdateChangeOrderLineItemPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemPutV2>>,
    TError,
    { data: BodyType<LineItemUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemPutV2>>,
  TError,
  { data: BodyType<LineItemUpdateRequest> },
  TContext
> => {
  const mutationKey = ["lineItemsUpdateChangeOrderLineItemPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemPutV2>>,
    { data: BodyType<LineItemUpdateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return lineItemsUpdateChangeOrderLineItemPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LineItemsUpdateChangeOrderLineItemPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemPutV2>>
>;
export type LineItemsUpdateChangeOrderLineItemPutV2MutationBody =
  BodyType<LineItemUpdateRequest>;
export type LineItemsUpdateChangeOrderLineItemPutV2MutationError =
  ErrorType<unknown>;

export const useLineItemsUpdateChangeOrderLineItemPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemPutV2>>,
    TError,
    { data: BodyType<LineItemUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemPutV2>>,
  TError,
  { data: BodyType<LineItemUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getLineItemsUpdateChangeOrderLineItemPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const lineItemsUpdateChangeOrderLineItemOrdersPutV2 = (
  changeOrderLineItemsOrderUpdateRequest: BodyType<ChangeOrderLineItemsOrderUpdateRequest>,
  params?: LineItemsUpdateChangeOrderLineItemOrdersPutV2Params,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/LineItems/update-change-order-line-item-orders`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: changeOrderLineItemsOrderUpdateRequest,
      params,
    },
    options,
  );
};

export const getLineItemsUpdateChangeOrderLineItemOrdersPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemOrdersPutV2>>,
    TError,
    {
      data: BodyType<ChangeOrderLineItemsOrderUpdateRequest>;
      params?: LineItemsUpdateChangeOrderLineItemOrdersPutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemOrdersPutV2>>,
  TError,
  {
    data: BodyType<ChangeOrderLineItemsOrderUpdateRequest>;
    params?: LineItemsUpdateChangeOrderLineItemOrdersPutV2Params;
  },
  TContext
> => {
  const mutationKey = ["lineItemsUpdateChangeOrderLineItemOrdersPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemOrdersPutV2>>,
    {
      data: BodyType<ChangeOrderLineItemsOrderUpdateRequest>;
      params?: LineItemsUpdateChangeOrderLineItemOrdersPutV2Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return lineItemsUpdateChangeOrderLineItemOrdersPutV2(
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type LineItemsUpdateChangeOrderLineItemOrdersPutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemOrdersPutV2>>
  >;
export type LineItemsUpdateChangeOrderLineItemOrdersPutV2MutationBody =
  BodyType<ChangeOrderLineItemsOrderUpdateRequest>;
export type LineItemsUpdateChangeOrderLineItemOrdersPutV2MutationError =
  ErrorType<unknown>;

export const useLineItemsUpdateChangeOrderLineItemOrdersPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemOrdersPutV2>>,
    TError,
    {
      data: BodyType<ChangeOrderLineItemsOrderUpdateRequest>;
      params?: LineItemsUpdateChangeOrderLineItemOrdersPutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemOrdersPutV2>>,
  TError,
  {
    data: BodyType<ChangeOrderLineItemsOrderUpdateRequest>;
    params?: LineItemsUpdateChangeOrderLineItemOrdersPutV2Params;
  },
  TContext
> => {
  const mutationOptions =
    getLineItemsUpdateChangeOrderLineItemOrdersPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Bulk-updates the ParentId/DisplayOrder of change order format items. Requires Change Orders permission.
 */
export const lineItemsChangeOrderFormatItemsBulkPutV2 = (
  bulkUpdateScopeOfWorkFormatItemsRequest: BodyType<BulkUpdateScopeOfWorkFormatItemsRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/LineItems/change-order-format-items/bulk`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: bulkUpdateScopeOfWorkFormatItemsRequest,
    },
    options,
  );
};

export const getLineItemsChangeOrderFormatItemsBulkPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsChangeOrderFormatItemsBulkPutV2>>,
    TError,
    { data: BodyType<BulkUpdateScopeOfWorkFormatItemsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lineItemsChangeOrderFormatItemsBulkPutV2>>,
  TError,
  { data: BodyType<BulkUpdateScopeOfWorkFormatItemsRequest> },
  TContext
> => {
  const mutationKey = ["lineItemsChangeOrderFormatItemsBulkPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lineItemsChangeOrderFormatItemsBulkPutV2>>,
    { data: BodyType<BulkUpdateScopeOfWorkFormatItemsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return lineItemsChangeOrderFormatItemsBulkPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LineItemsChangeOrderFormatItemsBulkPutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof lineItemsChangeOrderFormatItemsBulkPutV2>>
  >;
export type LineItemsChangeOrderFormatItemsBulkPutV2MutationBody =
  BodyType<BulkUpdateScopeOfWorkFormatItemsRequest>;
export type LineItemsChangeOrderFormatItemsBulkPutV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Bulk-updates the ParentId/DisplayOrder of change order format items. Requires Change Orders permission.
 */
export const useLineItemsChangeOrderFormatItemsBulkPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsChangeOrderFormatItemsBulkPutV2>>,
    TError,
    { data: BodyType<BulkUpdateScopeOfWorkFormatItemsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lineItemsChangeOrderFormatItemsBulkPutV2>>,
  TError,
  { data: BodyType<BulkUpdateScopeOfWorkFormatItemsRequest> },
  TContext
> => {
  const mutationOptions =
    getLineItemsChangeOrderFormatItemsBulkPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Bulk-updates the ParentId/DisplayOrder of estimate worksheet format items. Requires Estimates permission.
 */
export const lineItemsEstimateFormatItemsBulkPutV2 = (
  bulkUpdateScopeOfWorkFormatItemsRequest: BodyType<BulkUpdateScopeOfWorkFormatItemsRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/LineItems/estimate-format-items/bulk`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: bulkUpdateScopeOfWorkFormatItemsRequest,
    },
    options,
  );
};

export const getLineItemsEstimateFormatItemsBulkPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsEstimateFormatItemsBulkPutV2>>,
    TError,
    { data: BodyType<BulkUpdateScopeOfWorkFormatItemsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lineItemsEstimateFormatItemsBulkPutV2>>,
  TError,
  { data: BodyType<BulkUpdateScopeOfWorkFormatItemsRequest> },
  TContext
> => {
  const mutationKey = ["lineItemsEstimateFormatItemsBulkPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lineItemsEstimateFormatItemsBulkPutV2>>,
    { data: BodyType<BulkUpdateScopeOfWorkFormatItemsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return lineItemsEstimateFormatItemsBulkPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LineItemsEstimateFormatItemsBulkPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof lineItemsEstimateFormatItemsBulkPutV2>>
>;
export type LineItemsEstimateFormatItemsBulkPutV2MutationBody =
  BodyType<BulkUpdateScopeOfWorkFormatItemsRequest>;
export type LineItemsEstimateFormatItemsBulkPutV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Bulk-updates the ParentId/DisplayOrder of estimate worksheet format items. Requires Estimates permission.
 */
export const useLineItemsEstimateFormatItemsBulkPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsEstimateFormatItemsBulkPutV2>>,
    TError,
    { data: BodyType<BulkUpdateScopeOfWorkFormatItemsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lineItemsEstimateFormatItemsBulkPutV2>>,
  TError,
  { data: BodyType<BulkUpdateScopeOfWorkFormatItemsRequest> },
  TContext
> => {
  const mutationOptions =
    getLineItemsEstimateFormatItemsBulkPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const lineItemsUpdateChangeOrderLineItemProfitPutV2 = (
  updateScopeOfWorkLineItemProfitRequest: BodyType<UpdateScopeOfWorkLineItemProfitRequest>,
  params?: LineItemsUpdateChangeOrderLineItemProfitPutV2Params,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<UpdateScopeOfWorkLineItemProfitResponse>(
    {
      url: `/apix/v2/LineItems/update-change-order-line-item-profit`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: updateScopeOfWorkLineItemProfitRequest,
      params,
    },
    options,
  );
};

export const getLineItemsUpdateChangeOrderLineItemProfitPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemProfitPutV2>>,
    TError,
    {
      data: BodyType<UpdateScopeOfWorkLineItemProfitRequest>;
      params?: LineItemsUpdateChangeOrderLineItemProfitPutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemProfitPutV2>>,
  TError,
  {
    data: BodyType<UpdateScopeOfWorkLineItemProfitRequest>;
    params?: LineItemsUpdateChangeOrderLineItemProfitPutV2Params;
  },
  TContext
> => {
  const mutationKey = ["lineItemsUpdateChangeOrderLineItemProfitPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemProfitPutV2>>,
    {
      data: BodyType<UpdateScopeOfWorkLineItemProfitRequest>;
      params?: LineItemsUpdateChangeOrderLineItemProfitPutV2Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return lineItemsUpdateChangeOrderLineItemProfitPutV2(
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type LineItemsUpdateChangeOrderLineItemProfitPutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemProfitPutV2>>
  >;
export type LineItemsUpdateChangeOrderLineItemProfitPutV2MutationBody =
  BodyType<UpdateScopeOfWorkLineItemProfitRequest>;
export type LineItemsUpdateChangeOrderLineItemProfitPutV2MutationError =
  ErrorType<unknown>;

export const useLineItemsUpdateChangeOrderLineItemProfitPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemProfitPutV2>>,
    TError,
    {
      data: BodyType<UpdateScopeOfWorkLineItemProfitRequest>;
      params?: LineItemsUpdateChangeOrderLineItemProfitPutV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lineItemsUpdateChangeOrderLineItemProfitPutV2>>,
  TError,
  {
    data: BodyType<UpdateScopeOfWorkLineItemProfitRequest>;
    params?: LineItemsUpdateChangeOrderLineItemProfitPutV2Params;
  },
  TContext
> => {
  const mutationOptions =
    getLineItemsUpdateChangeOrderLineItemProfitPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const lineItemsDeleteChangeOrderLineItemsDeleteV2 = (
  deleteScopeOfWorkLineItemsRequest: BodyType<DeleteScopeOfWorkLineItemsRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/LineItems/delete-change-order-line-items`,
      method: "DELETE",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: deleteScopeOfWorkLineItemsRequest,
    },
    options,
  );
};

export const getLineItemsDeleteChangeOrderLineItemsDeleteV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsDeleteChangeOrderLineItemsDeleteV2>>,
    TError,
    { data: BodyType<DeleteScopeOfWorkLineItemsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lineItemsDeleteChangeOrderLineItemsDeleteV2>>,
  TError,
  { data: BodyType<DeleteScopeOfWorkLineItemsRequest> },
  TContext
> => {
  const mutationKey = ["lineItemsDeleteChangeOrderLineItemsDeleteV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lineItemsDeleteChangeOrderLineItemsDeleteV2>>,
    { data: BodyType<DeleteScopeOfWorkLineItemsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return lineItemsDeleteChangeOrderLineItemsDeleteV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LineItemsDeleteChangeOrderLineItemsDeleteV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof lineItemsDeleteChangeOrderLineItemsDeleteV2>>
  >;
export type LineItemsDeleteChangeOrderLineItemsDeleteV2MutationBody =
  BodyType<DeleteScopeOfWorkLineItemsRequest>;
export type LineItemsDeleteChangeOrderLineItemsDeleteV2MutationError =
  ErrorType<unknown>;

export const useLineItemsDeleteChangeOrderLineItemsDeleteV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lineItemsDeleteChangeOrderLineItemsDeleteV2>>,
    TError,
    { data: BodyType<DeleteScopeOfWorkLineItemsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lineItemsDeleteChangeOrderLineItemsDeleteV2>>,
  TError,
  { data: BodyType<DeleteScopeOfWorkLineItemsRequest> },
  TContext
> => {
  const mutationOptions =
    getLineItemsDeleteChangeOrderLineItemsDeleteV2MutationOptions(options);

  return useMutation(mutationOptions);
};
